var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M2.372 57.987V6.811c0-1.955 1.602-3.545 3.573-3.545h37.729c1.97 0 3.573 1.59 3.573 3.545v51.176c0 1.955-1.602 3.545-3.573 3.545H5.945c-1.971 0-3.573-1.59-3.573-3.544z",
    fill: "#291475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56.223V5.046c0-1.954 1.602-3.544 3.573-3.544h37.729c1.971 0 3.573 1.59 3.573 3.544v51.177c0 1.955-1.602 3.544-3.573 3.544H3.573C1.603 59.767 0 58.178 0 56.224z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.763 56.634l.001-51.995-38.658-.001-.001 51.995 38.658.001z",
    fill: "#FEFFFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.772 10.309H5.154v4.536h20.618v-4.536z",
    fill: "#B0B0B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M37.112 17.113H5.154v4.536h31.958v-4.536z",
    fill: "#B0B0B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.772 30.927H5.154v4.536h20.618v-4.536z",
    fill: "#B0B0B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M37.112 37.731H5.154v4.536h31.958V37.73z",
    fill: "#B0B0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.686 0H14.197a1.793 1.793 0 00-1.802 1.788v2.686c0 .993.809 1.788 1.802 1.788h16.489c.994 0 1.803-.803 1.803-1.788V1.788c0-.985-.81-1.788-1.803-1.788z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M31.36.127c.056.167.08.342.08.533v2.686c0 .993-.81 1.788-1.811 1.788H13.14c-.24 0-.473-.04-.681-.128a1.801 1.801 0 001.73 1.272h16.49c.993 0 1.802-.803 1.802-1.788V1.796A1.785 1.785 0 0031.36.127z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.459 2.543H16.417a.712.712 0 01-.713-.708c0-.39.32-.707.713-.707h12.05c.393 0 .713.318.713.707a.714.714 0 01-.721.708z",
    fill: "#B0B0B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M44.875 4.093l-.008 53.092a2.588 2.588 0 01-2.603 2.582H2.604C1.17 59.767 0 58.608 0 57.185v-2.066l37.448.008a2.595 2.595 0 002.604-2.591l.008-51.034h2.212a2.6 2.6 0 012.603 2.59z",
    fill: "#291475"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M58.489 19.355l-.651-.497-.66-.505a2.062 2.062 0 00-2.853.38l-2.487 3.229-.109.14-1.877 2.459-.109.14-16.582 21.612-.034.141-.333 1.4-.576 2.375-.576 2.383-.133.538 2.653-1.448.918-.505 2.504-1.366.117-.066h.008l17-22.15 1.585-2.052.092-.125 2.487-3.244c.183-.24.3-.514.359-.795a2.007 2.007 0 00-.743-2.044z",
    fill: "#291475"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.054 20.802l-2.487 3.245-.092.124-1.903 2.475-.092.116-16.582 21.612-.125.075-3.43 1.87-2.645 1.449.71-2.914.9-3.774.034-.141 16.582-21.612.108-.14 1.878-2.459.109-.14 2.486-3.229a2.055 2.055 0 012.855-.38l1.31 1.001a2.006 2.006 0 01.384 2.822z",
    fill: "#ED1B2E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.054 20.803l-3.013 3.923-4.473-3.534 2.93-3.824a2.055 2.055 0 012.853-.38l1.31 1a1.989 1.989 0 01.393 2.815z",
    fill: "#ED1B2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.567 24.047l-.092.124-1.903 2.475-4.656-3.319.117-.14 1.869-2.45 4.665 3.31z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.308 45.08l4.465 3.368-3.421 1.87-2.654 1.45.7-2.922.91-3.767z",
    fill: "#FFDF8C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.399 48.846l1.953 1.473-2.654 1.449.7-2.922z",
    fill: "#000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M56.01 17.483l.66.497a2.008 2.008 0 01.384 2.83L35.898 48.382l-.125.066-3.421 1.87-2.654 1.45L56.01 17.482z",
    fill: "#ED1B2E"
  })));
}

export default SvgTask;